module.exports = __webpack_public_path__ + "img/comment.40de99c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/indicateurs-icons/comment.svg
// module id = GxtJ
// module chunks = 7